import { FilterColumn } from '@blisspointmedia/bpm-types/dist/FilterBar';

export const DATE_FORMAT = 'yyyy-MM-dd';
export const PRETTY_DATE_FORMAT = 'M/d';

export const ROW_HEIGHT = 55;
export const HEADER_HEIGHT = 120;
export const COLUMN_WIDTH = 110;
export const COLUMN_SPACER_WIDTH = 2;
export const RIGHT_HEADER_WIDTH = 120;

export const BASE_PATH = '/active-streaming-media';

export const COMPANY_FILTER_OPTIONS: FilterColumn[] = [
  { name: 'shortCode', label: 'Network' },
  { name: 'platform', label: 'Platform' },
  { name: 'description', label: 'Description' },
  { name: 'audioBuyType', label: 'Audio Buy Type' }
];

export const NETWORK_FILTER_OPTIONS: FilterColumn[] = [
  { name: 'cid', label: 'Company' },
  { name: 'platform', label: 'Platform' },
  { name: 'description', label: 'Description' },
  { name: 'audioBuyType', label: 'Audio Buy Type' }
];

export interface DateRange {
  start: string;
  end: string;
}

export interface DimensionsState {
  spend: boolean;
  cpm: boolean;
}

// A header is either a network-mode column (keyed by company `cid`) or a company-mode
// column (keyed by network `shortCode`) — the two modes share the rest of the fields.
export interface Header {
  key: string;
  cid?: string;
  shortCode?: string;
  platform: string;
  description?: string;
  audioBuyType?: string;
}

export type HeaderMetaData = Omit<Header, 'key'>;

export interface DataRowValues {
  media: number;
  adServingFee: number;
  dspCpmFee: number;
  dspCommissionFee: number;
  agencyCommission: number;
  impressions: number;
}

export interface DataRow extends DataRowValues {
  metaData: HeaderMetaData;
  flights: string[];
  overrides?: DataRowValues;
}

export interface WeekEntry {
  week: string;
  data: Record<string, DataRow[]>;
}

export interface CompanyOption {
  cid: string;
}

// networkOptions[networkName][cid] -> the metadata lines that company buys on that network
export type NetworkOptions = Record<string, Record<string, HeaderMetaData[]>>;

export interface ExpectedBookingEntry {
  media: number;
  adServingFee: number;
  dspCpmFee: number;
  agencyCommission: number;
}

export type ExpectedBookings = Record<
  string,
  { streaming?: ExpectedBookingEntry; audio?: ExpectedBookingEntry }
>;

export interface Flight {
  id: string;
  orderID: string;
  startDate: string;
  endDate: string;
  spend: number;
  cpm?: number;
  impressions: number;
  platform?: string;
  description?: string;
  shortCode?: string;
  key?: string; // cid, only present in network mode
  properties?: string[];
  canceled?: string;
  overrides?: { spend: number; impressions: number };
  derivedNetwork?: string;
  pdfText?: string;
}

export interface ActiveOTTData {
  headers?: Header[];
  weeks?: WeekEntry[];
  flightMap?: Record<string, Flight>;
}

export interface CellData {
  week: string;
  flights?: string[];
  spend?: number;
  adServingFee?: number;
  dspCpmFee?: number;
  dspCommissionFee?: number;
  commission?: number;
  includeFees?: boolean;
  includeCommission?: boolean;
  cpm?: number;
}

export interface RightTotal {
  week: string;
  spend: number;
  expected: number;
}

export interface ActiveOTTContextValue {
  byNetwork: boolean;
  selectedGroup: CompanyOption | string;
  setSelectedGroup: (key: string) => void;
  networkOptions?: NetworkOptions;
  companyOptions?: CompanyOption[];
  flightMap?: Record<string, Flight>;
}
